import React, { createContext, ReactElement, useState, useMemo, Dispatch, SetStateAction, useEffect, useCallback } from "react";
import { cachearContexto } from "../../helpers/cachearContexto";
import { ArquitetoService } from "../../services/ArquitetoService";
import { ArquitetoType } from "./types";

interface ArquitetoContextProps {
  arquitetos: ArquitetoType[];
  setArquitetos: Dispatch<SetStateAction<ArquitetoType[]>>;
  arquitetosPage: ArquitetoType[];
  setArquitetosPage: Dispatch<SetStateAction<ArquitetoType[]>>;
  carregarArquitetos: () => void;
  handleAdicionarArquiteto: (arquiteto:ArquitetoType) => void;
  handleAtualizarArquiteto: (idArquiteto:number, arquiteto:ArquitetoType) => void;
  handleRemoveArquiteto: (idArquiteto:number) => void;
  arquitetoSelecionado: ArquitetoType;
  setArquitetoSelecionado: Dispatch<SetStateAction<ArquitetoType>>
}

export const ArquitetoContext = createContext({} as ArquitetoContextProps);

export function ArquitetoProvider({ children }: { children: ReactElement }) {
  const [arquitetos, setArquitetos] = useState<ArquitetoType[]>([] as ArquitetoType[])
  const [arquitetosPage, setArquitetosPage] = useState<ArquitetoType[]>([] as ArquitetoType[])
  const [arquitetoSelecionado, setArquitetoSelecionado] = useState<ArquitetoType>({} as ArquitetoType)

  const carregarArquitetos = useCallback(()=>{
    cachearContexto(arquitetos, setArquitetos, ArquitetoService.search);
  },[])

  const handleAdicionarArquiteto = (arquiteto:ArquitetoType)=>{
    setArquitetosPage((current) => [arquiteto, ...current]);
  }

  const handleAtualizarArquiteto = (idArquiteto:number, arquiteto:ArquitetoType) => {
    setArquitetosPage((current) => {
      return current.map((item) => {
         if(item?.id === idArquiteto){
           return arquiteto;
         }
         return item;
      })
    })
    if(arquitetos?.length){
      setArquitetos((current)=>{
        return current.map((item) => {
           if(item?.id === idArquiteto){
             return arquiteto;
           }
           return item;
        })
      })
    }
  }

  const handleRemoveArquiteto = (idArquiteto:number) => {
    setArquitetosPage((current) => current.filter((item) => item.id !== idArquiteto));
    if(arquitetos?.length){
      setArquitetosPage((current) => current.filter((item) => item.id !== idArquiteto));
    }
  }

  const values = useMemo(()=>{
    return{
      arquitetos,
      setArquitetos,
      arquitetosPage,
      setArquitetosPage,
      handleAdicionarArquiteto,
      handleAtualizarArquiteto,
      handleRemoveArquiteto,
      arquitetoSelecionado,
      setArquitetoSelecionado,
      carregarArquitetos,
    }
  },[arquitetos, arquitetoSelecionado, arquitetoSelecionado, arquitetosPage])

  return (
      <ArquitetoContext.Provider
        value={values}
      >
          {children}
      </ArquitetoContext.Provider>
  );
}
